import DiscountNotification from './DiscountNotification';

export default DiscountNotification;
